import React from 'react';
import { useParams } from 'react-router-dom';
import { Text } from '@perch-labs/shrike';
import { BackLink } from 'components/back-link';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { useBillingStatus } from 'hooks/use-billing-status.hook';
import { StatementRow } from 'pages/billing/components/statement-row';
import { copyFor, routes } from 'config';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import { Page, Container } from 'styles';

const getCopy = copyFor('billing.statements');
const getBackLinkCopy = copyFor('navigation.backLink.dashboardLocations');

export const Statements = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { billing } = routes({ planId });
  const { data, error, loading } = useBillingStatus({
    planId: Number(planId),
  });

  if (loading) {
    return <LoadingPage numberOfSections={2} />;
  }
  if (error) {
    return <ErrorPage to={billing} title={getCopy('title')} />;
  }
  const issuedStatements = data.issuedStatements || [];

  return (
    <>
      <BackLink to={billing} location={getBackLinkCopy('billing')} />
      <Page
        maxWidth={MAX_SECONDARY_PAGE_WIDTH}
        small={{ padding: '0 0 40px 24px' }}
      >
        <Container
          margin={{ bottom: '40px' }}
          small={{ margin: { bottom: '32px', top: '24px' } }}
        >
          <Text tag="h1" textStyle="heading800">
            {getCopy('title')}
          </Text>
        </Container>
        {issuedStatements.map(statement => (
          <StatementRow
            statement={statement}
            key={`all-statements-id-${statement.id}`}
          />
        ))}
      </Page>
    </>
  );
};
